import { APICallV3Post } from 'reactApp/api/APICall';
import type { WopiData } from 'reactApp/api/wopi/WopiAPI.types';
import { CloudActions } from 'reactApp/constants/cloudActions';

export class WopiViewAPICall extends APICallV3Post<WopiData> {
    _method = 'wopi-go/view';
    _headers = { 'X-VFS-Action': CloudActions.FILE_READ };
}

export class WopiEmbeddedViewAPICall extends APICallV3Post<WopiData> {
    _method = 'wopi-go/embedded/view_direct';
}
